import React from 'react';
import { FaTimes } from "react-icons/fa";
import './Polytermandservices.css'; // Create a CSS file for styling

const Polytermandservices = () => {
  const handleBack = () => {
    window.history.back(); // Or use navigate if you prefer
  };

  return (
    <div className="Polytermandservices-page">
      <div className="Polytermandservices-container">
        <div className="Polytermandservices-header">
          <h1>PolyMatch Global Competitions – Terms & Conditions</h1>
          <button 
            className="Polytermandservices-close"
            onClick={handleBack}
          >
            <FaTimes />
          </button>
        </div>
        <div className="Polytermandservices-content">
          <p>By registering for and participating in PolyMatch Global Competitions, organized under the umbrella of Polymath-Kids, you agree to the following Terms & Conditions:</p>
          
          <h3>1. Eligibility</h3>
          <p>Competitions are open to children within the specified age groups (4–16 years) at the time of registration.</p>
          <p>Registration must be completed by a parent/guardian or an authorized school representative.</p>

          <h3>2. Registration & Fees</h3>
          <p>Registration is confirmed only after payment of the competition fee.</p>
          <p>Fees are non-refundable, except in cases where the competition is cancelled by Polymath-Kids.</p>
          <p>One registration per participant per competition category is allowed.</p>

          <h3>3. Competition Rules</h3>
          <p>Participants must log in with their official PolyMatch credentials at the scheduled time.</p>
          <p>Any form of cheating, impersonation, or use of unfair means will result in immediate disqualification.</p>
          <p>The competition will be conducted in English (or other specified languages where applicable).</p>

          <h3>4. Technology & Access</h3>
          <p>Competitions are conducted online; participants are responsible for arranging their own device, stable internet connection, and environment.</p>
          <p>Polymath-Kids is not responsible for disruptions due to technical issues on the participant's end.</p>

          <h3>5. Evaluation & Results</h3>
          <p>All results are final and based on automated systems and/or independent judges' evaluation (depending on the category).</p>
          <p>No correspondence regarding scoring or ranking will be entertained.</p>
          <p>Certificates, medals, and trophies (where applicable) will be awarded as per the announced criteria.</p>

          <h3>6. Data Protection & Privacy</h3>
          <p>Participant details (name, age, country, school, etc.) may be published on leaderboards, certificates, and promotional material.</p>
          <p>All personal data will be handled in accordance with Polymath-Kids' Privacy Policy.</p>

          <h3>7. Intellectual Property</h3>
          <p>All competition content (questions, challenges, platforms, etc.) is the intellectual property of Polymath-Kids and cannot be copied, distributed, or reused without permission.</p>

          <h3>8. Code of Conduct</h3>
          <p>Parents/guardians must ensure that children participate ethically and independently.</p>
          <p>Respectful online behavior is mandatory; any misconduct may lead to disqualification.</p>

          <h3>9. Liability</h3>
          <p>Polymath-Kids shall not be held liable for any loss, damage, or injury incurred during participation.</p>
          <p>Participation is voluntary and at the sole discretion of the parent/guardian.</p>

          <h3>10. Amendments</h3>
          <p>Polymath-Kids reserves the right to amend the Terms & Conditions, competition format, or schedule at any time.</p>
          <p>Updates will be communicated via the official website and email.</p>
        </div>
        <div className="Polytermandservices-footer">
          <button 
            className="Polytermandservices-back-button"
            onClick={handleBack}
          >
            Back to Registration
          </button>
        </div>
      </div>
    </div>
  );
};

export default Polytermandservices;